//
// Copyright 2020 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/echo/object.proto (package dxos.echo.object, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any, file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import { file_dxos_field_options } from "../field_options_pb.js";
import type { PublicKey } from "../keys_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import { file_dxos_halo_credentials } from "../halo/credentials_pb.js";
import type { TimeframeVector } from "./timeframe_pb.js";
import { file_dxos_echo_timeframe } from "./timeframe_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/echo/object.proto.
 */
export const file_dxos_echo_object: GenFile = /*@__PURE__*/
  fileDesc("ChZkeG9zL2VjaG8vb2JqZWN0LnByb3RvEhBkeG9zLmVjaG8ub2JqZWN0IqgGCgpFY2hvT2JqZWN0EhEKCW9iamVjdF9pZBgBIAEoCRIxCgRtZXRhGAIgASgLMh4uZHhvcy5lY2hvLm9iamVjdC5NdXRhdGlvbk1ldGFIAIgBARI6CgdnZW5lc2lzGAogASgLMiQuZHhvcy5lY2hvLm9iamVjdC5FY2hvT2JqZWN0LkdlbmVzaXNIAYgBARI8CghzbmFwc2hvdBgNIAEoCzIlLmR4b3MuZWNoby5vYmplY3QuRWNob09iamVjdC5TbmFwc2hvdEgCiAEBEjgKCW11dGF0aW9ucxgOIAMoCzIlLmR4b3MuZWNoby5vYmplY3QuRWNob09iamVjdC5NdXRhdGlvbhpLCgdHZW5lc2lzEhIKCm1vZGVsX3R5cGUYAiABKAkSGgoNbW9kZWxfdmVyc2lvbhgDIAEoCUgAiAEBQhAKDl9tb2RlbF92ZXJzaW9uGowBCghTbmFwc2hvdBIUCgdkZWxldGVkGAEgASgISACIAQESFgoJcGFyZW50X2lkGAIgASgJSAGIAQESLgoFbW9kZWwYCiABKAsyFC5nb29nbGUucHJvdG9idWYuQW55QgSA9AMBSAKIAQFCCgoIX2RlbGV0ZWRCDAoKX3BhcmVudF9pZEIICgZfbW9kZWwaoQIKCE11dGF0aW9uEjEKBG1ldGEYASABKAsyHi5keG9zLmVjaG8ub2JqZWN0Lk11dGF0aW9uTWV0YUgAiAEBEhYKCXBhcmVudF9pZBgKIAEoCUgBiAEBEkEKBmFjdGlvbhgLIAEoDjIsLmR4b3MuZWNoby5vYmplY3QuRWNob09iamVjdC5NdXRhdGlvbi5BY3Rpb25IAogBARIuCgVtb2RlbBgMIAEoCzIULmdvb2dsZS5wcm90b2J1Zi5BbnlCBID0AwFIA4gBASIrCgZBY3Rpb24SCAoETk9PUBAAEgoKBkRFTEVURRABEgsKB1JFU1RPUkUQAkIHCgVfbWV0YUIMCgpfcGFyZW50X2lkQgkKB19hY3Rpb25CCAoGX21vZGVsQgcKBV9tZXRhQgoKCF9nZW5lc2lzQgsKCV9zbmFwc2hvdCKAAgoMTXV0YXRpb25NZXRhEisKCGZlZWRfa2V5GAEgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleUgAiAEBEhAKA3NlcRgCIAEoBUgBiAEBEi0KCm1lbWJlcl9rZXkYAyABKAsyFC5keG9zLmtleXMuUHVibGljS2V5SAKIAQESPAoJdGltZWZyYW1lGAQgASgLMiQuZHhvcy5lY2hvLnRpbWVmcmFtZS5UaW1lZnJhbWVWZWN0b3JIA4gBARISCgpjbGllbnRfdGFnGAUgAygJQgsKCV9mZWVkX2tleUIGCgRfc2VxQg0KC19tZW1iZXJfa2V5QgwKCl90aW1lZnJhbWViBnByb3RvMw", [file_google_protobuf_any, file_google_protobuf_descriptor, file_dxos_field_options, file_dxos_keys, file_dxos_halo_credentials, file_dxos_echo_timeframe]);

/**
 * *
 * Wrapper for all ECHO messages.
 *
 * @generated from message dxos.echo.object.EchoObject
 */
export type EchoObject = Message<"dxos.echo.object.EchoObject"> & {
  /**
   * @generated from field: string object_id = 1;
   */
  objectId: string;

  /**
   * / Metadata for the genesis mutation.
   *
   * @generated from field: optional dxos.echo.object.MutationMeta meta = 2;
   */
  meta?: MutationMeta;

  /**
   * / Present in mutations creating new items and snapshots.
   *
   * @generated from field: optional dxos.echo.object.EchoObject.Genesis genesis = 10;
   */
  genesis?: EchoObject_Genesis;

  /**
   * @generated from field: optional dxos.echo.object.EchoObject.Snapshot snapshot = 13;
   */
  snapshot?: EchoObject_Snapshot;

  /**
   * / May be present in snapshots. In that case the mutations must be applied on top of the snapshot.
   *
   * @generated from field: repeated dxos.echo.object.EchoObject.Mutation mutations = 14;
   */
  mutations: EchoObject_Mutation[];
};

/**
 * Describes the message dxos.echo.object.EchoObject.
 * Use `create(EchoObjectSchema)` to create a new message.
 */
export const EchoObjectSchema: GenMessage<EchoObject> = /*@__PURE__*/
  messageDesc(file_dxos_echo_object, 0);

/**
 * @generated from message dxos.echo.object.EchoObject.Genesis
 */
export type EchoObject_Genesis = Message<"dxos.echo.object.EchoObject.Genesis"> & {
  /**
   * @generated from field: string model_type = 2;
   */
  modelType: string;

  /**
   * @generated from field: optional string model_version = 3;
   */
  modelVersion?: string;
};

/**
 * Describes the message dxos.echo.object.EchoObject.Genesis.
 * Use `create(EchoObject_GenesisSchema)` to create a new message.
 */
export const EchoObject_GenesisSchema: GenMessage<EchoObject_Genesis> = /*@__PURE__*/
  messageDesc(file_dxos_echo_object, 0, 0);

/**
 * @generated from message dxos.echo.object.EchoObject.Snapshot
 */
export type EchoObject_Snapshot = Message<"dxos.echo.object.EchoObject.Snapshot"> & {
  /**
   * TODO(dmaretskyi): Change to enum?
   *
   * @generated from field: optional bool deleted = 1;
   */
  deleted?: boolean;

  /**
   * @generated from field: optional string parent_id = 2;
   */
  parentId?: string;

  /**
   * / Set the model to the provided snapshot.
   *
   * @generated from field: optional google.protobuf.Any model = 10;
   */
  model?: Any;
};

/**
 * Describes the message dxos.echo.object.EchoObject.Snapshot.
 * Use `create(EchoObject_SnapshotSchema)` to create a new message.
 */
export const EchoObject_SnapshotSchema: GenMessage<EchoObject_Snapshot> = /*@__PURE__*/
  messageDesc(file_dxos_echo_object, 0, 1);

/**
 * @generated from message dxos.echo.object.EchoObject.Mutation
 */
export type EchoObject_Mutation = Message<"dxos.echo.object.EchoObject.Mutation"> & {
  /**
   * @generated from field: optional dxos.echo.object.MutationMeta meta = 1;
   */
  meta?: MutationMeta;

  /**
   * / Set parent id
   *
   * @generated from field: optional string parent_id = 10;
   */
  parentId?: string;

  /**
   * @generated from field: optional dxos.echo.object.EchoObject.Mutation.Action action = 11;
   */
  action?: EchoObject_Mutation_Action;

  /**
   * Encoded model mutation, format is defined by model's codec.
   *
   * @generated from field: optional google.protobuf.Any model = 12;
   */
  model?: Any;
};

/**
 * Describes the message dxos.echo.object.EchoObject.Mutation.
 * Use `create(EchoObject_MutationSchema)` to create a new message.
 */
export const EchoObject_MutationSchema: GenMessage<EchoObject_Mutation> = /*@__PURE__*/
  messageDesc(file_dxos_echo_object, 0, 2);

/**
 * @generated from enum dxos.echo.object.EchoObject.Mutation.Action
 */
export enum EchoObject_Mutation_Action {
  /**
   * @generated from enum value: NOOP = 0;
   */
  NOOP = 0,

  /**
   * @generated from enum value: DELETE = 1;
   */
  DELETE = 1,

  /**
   * @generated from enum value: RESTORE = 2;
   */
  RESTORE = 2,
}

/**
 * Describes the enum dxos.echo.object.EchoObject.Mutation.Action.
 */
export const EchoObject_Mutation_ActionSchema: GenEnum<EchoObject_Mutation_Action> = /*@__PURE__*/
  enumDesc(file_dxos_echo_object, 0, 2, 0);

/**
 * @generated from message dxos.echo.object.MutationMeta
 */
export type MutationMeta = Message<"dxos.echo.object.MutationMeta"> & {
  /**
   * @generated from field: optional dxos.keys.PublicKey feed_key = 1;
   */
  feedKey?: PublicKey;

  /**
   * @generated from field: optional int32 seq = 2;
   */
  seq?: number;

  /**
   * @generated from field: optional dxos.keys.PublicKey member_key = 3;
   */
  memberKey?: PublicKey;

  /**
   * @generated from field: optional dxos.echo.timeframe.TimeframeVector timeframe = 4;
   */
  timeframe?: TimeframeVector;

  /**
   * / If this mutation was created by this client, this field will be set to the tag in the mutation.
   *
   * @generated from field: repeated string client_tag = 5;
   */
  clientTag: string[];
};

/**
 * Describes the message dxos.echo.object.MutationMeta.
 * Use `create(MutationMetaSchema)` to create a new message.
 */
export const MutationMetaSchema: GenMessage<MutationMeta> = /*@__PURE__*/
  messageDesc(file_dxos_echo_object, 1);

